import React from 'react';
import styled from 'styled-components'
import { store } from '../../App'
import { sides } from '../../sections/auth/reducer'
import { connect } from 'react-redux'

const Container = styled.div`
    width: 100%;
`

class MobileTest extends React.Component {

    onLogoutClick = () => {
        const { dispatch } = this.props
        dispatch(sides.logout())
    }

    componentDidMount() {
        var state = store.getState();

        if (state && state.auth && state.auth.user && state.auth.user.profile) {
            var userName = state.auth.user.profile.name
            var userId = state.auth.user.profile.upn
        }

        let host = "goldieproduction.azurewebsites.net";

        if (process.env.CONFIGURATION == "Production") {
            host = "goldieproduction.azurewebsites.net";
        }

        function onNotAuthorized() {
            window.alert("You are not authorized to access Goldie. Please contact Kerrie Barker or Taryn Saxionis for more information.");
        }

        if (userId != null && userId.length > 0) {
            fetch(`https://${host}/api/users?upn=${userId}`).then(response => response.json().then(x => {
                if (x.length > 0) {
                    document.getElementById("webchat").setAttribute("host", host);
                    document.getElementById("webchat").setAttribute("user-id", userId);
                    document.getElementById("webchat").setAttribute("user-name", userName);
                }
                else {
                    onNotAuthorized();
                }
            }).catch(x => {
                onNotAuthorized();
            }));
        }
    }

    render() {
        const styles = {
            button: {
                position: "absolute",
                zIndex: "2",
                right: "5px",
                top: "1px",
                background: "#ff0000",
                color: "#fff",
                padding: "5px 10px",
                opacity: "1"
            }
        }

        return (
            <Container className="mobileChat">
                <button className="close" style={styles.button} onClick={this.onLogoutClick}>Logout</button>
                <div id="webchat" className="webchat" role="main"></div>
            </Container>
        )
    }
}

export default connect(state => state)(MobileTest);